import { StorageKeys, ConfigStrings, ErrorCodes } from 'src/app/utils/common-classes';
import { HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/material/dialog";
export class AuthService {
    constructor(httpClient, dialogRef) {
        this.httpClient = httpClient;
        this.dialogRef = dialogRef;
        this.token = localStorage.getItem(StorageKeys.TOKEN);
    }
    getToken() {
        return this.token;
    }
    setToken(token) {
        this.token = token;
        localStorage.setItem(StorageKeys.TOKEN, token);
    }
    getHeaders() {
        let _self = this;
        if (_self.token) {
            return new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + this.token });
        }
        else {
            return new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
        }
    }
    login(username, password) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.getHeaders();
            const body = { email: username, password: password, tenantId: 'elettric80' };
            _self.httpClient.post(ConfigStrings.API_URL + "/login", body, { headers: headers }).subscribe((data) => {
                if (data && data.token) {
                    _self.setToken(data.token);
                    resolve();
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    logout() {
        let _self = this;
        _self.dialogRef.closeAll();
        return new Promise((resolve, reject) => {
            new Promise((innResolve, innReject) => {
                const headers = _self.getHeaders();
                _self.httpClient.post(ConfigStrings.API_URL + "/logout", null, { headers: headers }).subscribe(() => {
                    innResolve();
                }, (error) => {
                    innReject(error);
                });
            }).then(() => {
                return Promise.resolve();
            }).catch((err) => {
                console.error(err);
                return Promise.resolve();
            }).then(() => {
                _self.removeToken();
                resolve();
            });
        });
    }
    removeToken() {
        this.token = null;
        localStorage.removeItem(StorageKeys.TOKEN);
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MatDialog)); }, token: AuthService, providedIn: "root" });
